import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Card } from "@redotech/redo-web/card";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { useRateCalculatorDispatch } from "./hooks";
import { RateCalculatorProvider } from "./oms-pricing-tool-context";
import { RateCalculatorWizard } from "./oms-pricing-tool-wizard";

const RateCalculatorCardContent = memo(function RateCalculatorCardContent() {
  const dispatch = useRateCalculatorDispatch();

  return (
    <>
      <Card title="OMS Pricing Tool" w="full">
        <Flex dir="column" gap="md">
          <Text fontSize="sm">
            Analyze merchant shipping data, check carrier eligibility, and
            generate competitive rate quotes. Upload a carrier invoice or use
            historical shipment data to calculate optimal pricing.
          </Text>
          <Flex>
            <RedoButton
              hierarchy="primary"
              onClick={() => dispatch({ type: "OPEN_WIZARD" })}
              size="sm"
              text="Open OMS Pricing Tool"
            />
          </Flex>
        </Flex>
      </Card>
      <RateCalculatorWizard />
    </>
  );
});

export const RateCalculatorCard = memo(function RateCalculatorCard() {
  return (
    <RateCalculatorProvider>
      <RateCalculatorCardContent />
    </RateCalculatorProvider>
  );
});
